module.exports = __webpack_public_path__ + "static/media/68.79d40e2b.jpg";